<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>
          <span style="color: red">Edit Journal Entry</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn color="primary" small text to="/edit/journal/entry">
          <v-icon left dark>mdi-keyboard-backspace</v-icon>Back
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <editor :initial="ojdt"></editor>
      </v-card-text>
    </v-card>

    <snackbar ref="snackbar"></snackbar>
  </v-container>
</template>

<script>
import Editor from "./_components/editor.vue";
export default {
  components: {
    Editor,
  },
  computed: {},
  data: () => ({
    ojdt: {},
    DefaultCustomer: null,
    AccountsVersion: null,
    outsourcedData: [],
    salePayments: [],
    docCreate: false,
    copyStatus: false,
  }),
  watch: {
    "$route.params.id": {
      handler: "getById",
      immediate: true,
    },
  },
  methods: {
    getById(val) {
      const self = this;
      // get record
      this.$store
        .dispatch("get", `/single-ojdt/${val}`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.ojdt = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {},
};
</script>